import { Box, createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import Carousel from 'components/UI/V2/Carousel/Carousel';
import { Fragment, FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { getSMSSlides } from './Slides';
import SMSDescription from './SMSDescription';
import ReactDOMServer from 'react-dom/server';
import Button from 'components/UI/V2/Button/Button';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            fontSize: 15,
            lineHeight: 1.4,
            display: 'flex',
            textAlign: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: '#fff'
        },
        icon: {
            margin: '0px auto 15px',
            [theme.breakpoints.down('xs')]: {
                margin: '0px auto 25px'
            }
        },
        title: {
            [theme.breakpoints.down('lg')]: {
                fontSize: '20px',
                fontWeight: 600
            },
            [theme.breakpoints.only('lg')]: {
                fontSize: '27px',
                fontWeight: 600
            },
            [theme.breakpoints.up('xl')]: {
                fontSize: '36px',
                fontWeight: 600
            }
        },
        container: {
            backgroundColor: 'white',
            [theme.breakpoints.down('md')]: {
                paddingTop: '40px'
            },
            [theme.breakpoints.up('lg')]: {
                paddingTop: '50px'
            }
        },
        headerContainer: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            [theme.breakpoints.down('sm')]: {
                paddingBottom: '20px'
            }
        },

        leftContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            marginLeft: '100px',
            [theme.breakpoints.down('lg')]: {
                marginLeft: '5%'
            }
        },

        rightContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            [theme.breakpoints.down('lg')]: {
                marginRight: '5%'
            },
            [theme.breakpoints.only('lg')]: {
                marginRight: '105px'
            },
            [theme.breakpoints.up('xl')]: {
                marginRight: '140px'
            }
        },

        tutorialContainer: {
            justifyContent: 'center',
            marginTop: '5%',
            marginBottom: '15px'
        }
    })
);

const SMSCampaignsIsEmpty: FunctionComponent = () => {
    const classes = useStyles();

    const smsDescriptionHTML = ReactDOMServer.renderToString(<SMSDescription />);
    const smsSlides = getSMSSlides(smsDescriptionHTML);

    return (
        <Fragment>
            <Grid
                container
                className={classes.container}
            >
                <Box className={classes.headerContainer}>
                    <Box className={classes.leftContainer}>
                        <Typography className={classes.title}>SMS campaigns</Typography>
                    </Box>
                </Box>
                <Grid
                    container
                    className={classes.tutorialContainer}
                >
                    <Carousel slides={smsSlides} />
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default SMSCampaignsIsEmpty;
